import React from 'react'
import styles from './styles.css'
import AutoForm from 'App/components/AutoForm'
import useMessage from 'App/hooks/useMessage'

export default function Priority(props) {
  const {conversation} = props
  const showMessage = useMessage()

  return (
    <div className={styles.container}>
      <AutoForm
        autoSave
        doc={{conversationId: conversation._id, priority: conversation.priority}}
        mutation="setConversationPriority"
        only="priority"
        onSuccess={() => showMessage('Prioridad actualizada')}
      />
    </div>
  )
}
